import React from 'react';
import PriceRangeFilter from './PriceRangeFilter';

export const QUANTITY_MIN = 0;
export const QUANTITY_MAX = 10000;

const formatSft = (v) => Number(v || 0).toLocaleString('en-IN', { maximumFractionDigits: 0 });

// Same slider as Price range, in available SFT. Like price, the top end means
// "10,000 SFT and above", so larger products are never silently excluded.
const QUANTITY_CONFIG = {
  min: QUANTITY_MIN,
  max: QUANTITY_MAX,
  title: 'Quantity',
  subtitle: 'available SFT',
  prefix: '',
  suffix: 'SFT',
  ariaNoun: 'available SFT',
  format: (v, upper) => `${formatSft(v)}${upper ? '+' : ''} SFT`,
  formatTick: (v, upper) => (v >= 1000 ? `${+(v / 1000).toFixed(1)}k${upper ? '+' : ''}` : `${v}`),
  ticks: [0, 1000, 5000, QUANTITY_MAX],
  presets: [
    { label: 'Under 500', range: [0, 500] },
    { label: '500 – 1,000', range: [500, 1000] },
    { label: '1,000 – 2,500', range: [1000, 2500] },
    { label: '2,500+', range: [2500, QUANTITY_MAX] },
  ],
};

/**
 * Quantity (available SFT) range filter with a live product count.
 *
 * value       [min, max] in SFT
 * quantities  persisted availableSft (from the API) of every product matching the other filters
 * onChange    called while dragging (display only)
 * onCommit    called once with the final range
 */
const QuantityRangeFilter = ({ value, quantities = [], loading = false, onChange, onCommit }) => (
  <PriceRangeFilter
    value={value}
    prices={quantities}
    loading={loading}
    onChange={onChange}
    onCommit={onCommit}
    config={QUANTITY_CONFIG}
  />
);

export default QuantityRangeFilter;
